export const LIST_READING_SESSION_AUDIT = 'LIST_READING_SESSION_AUDIT';
export const STORE_READING_SESSION_AUDIT = 'STORE_READING_SESSION_AUDIT';
export const LIST_WEEKLY_REPORT_AUDIT = 'LIST_WEEKLY_REPORT_AUDIT';
export const STORE_WEEKLY_REPORT_AUDIT = 'STORE_WEEKLY_REPORT_AUDIT';
